import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagEu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 16",
	width: 24,
	height: 16,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("polygon", {
			id: "s",
			fill: "#FFCC00",
			points: "0,-0.65 0.146,-0.201 0.618,-0.201 0.236,0.077 0.382,0.526 0,0.248 -0.382,0.526 -0.236,0.077 -0.618,-0.201 -0.146,-0.201"
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "#003399"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(12,3.5)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(14.25,4.1)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(15.9,5.75)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(16.5,8)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(15.9,10.25)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(14.25,11.9)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(12,12.5)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(9.75,11.9)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(8.1,10.25)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(7.5,8)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(8.1,5.75)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#s",
			transform: "translate(9.75,4.1)"
		})
	]
});
export default SvgFlagEu;
